/**
 * @fileoverview POST handler for the "/apps/multi_language_settings/upload_translations" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appsMultiLanguageSettingsUploadTranslationsCacheKeys } from "./constants";
import type {
  PostAppsMultiLanguageSettingsUploadTranslationsProps,
  AppsMultiLanguageSettingsUploadTranslationsResult,
  UploadTranslationsErrors,
} from "./types";

export const postAppsMultiLanguageSettingsUploadTranslations = reactQueryMutationAdapter(
  appsMultiLanguageSettingsUploadTranslationsCacheKeys,
  createMutationFetcherFunctionWithShadowError<UploadTranslationsErrors>()(
    (
      props: PostAppsMultiLanguageSettingsUploadTranslationsProps
    ): Promise<AppsMultiLanguageSettingsUploadTranslationsResult> => {
      const translationsParam = props.translations.map((translation) => {
        return {
          translation_map: JSON.stringify(translation.translationMap),
          locale_key: translation.localeKey,
        };
      });
      return fetch(
        "/apps/multi_language_settings/upload_translations",
        "POST",
        {
          locale_ids: props.localeIds,
          uploaded_defaults: JSON.stringify(props.uploadedDefaults),
          translations: translationsParam,
          message: props.message,
        },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
